/**
 * Reference manifest for the Gantt task bar.
 *
 * Epic SP-A (#1386) replaces the rounded-rect scaffold renderer with a
 * real task bar — progress fill, duration-proportional width, start/end
 * date labels, critical-path highlighting, and milestone-diamond
 * neighbors. The manifest id `gantt_task` is the contract: ingestion,
 * agent tools, and the Strategy Pack viewer all look it up by id.
 */

import { createPlanningManifest, type PlanningNodeProps } from '../manifest-base';

export const GanttTaskManifest = createPlanningManifest({
  id: 'gantt_task',
  domain: 'gantt',
  label: 'Task',
  accent: '#3b82f6',
  icon: 'rectangle',
  defaultWidth: 260,
  defaultHeight: 44,
});

export type GanttTaskProps = PlanningNodeProps;
